import axiosInstance from '../config/axiosConfig';

const facturationService = {
    // Récupérer toutes les factures (avec pagination et filtres)
    async getFactures(page = 1, limit = 10, filters = {}) {
        try {
            // Filtrer les valeurs undefined ou null pour éviter d'envoyer "undefined" comme chaîne de caractères
            const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    acc[key] = value;
                }
                return acc;
            }, {});

            const queryParams = new URLSearchParams({
                page,
                limit,
                ...cleanFilters
            }).toString();

            const response = await axiosInstance.get(`/factures-list?${queryParams}`);

            return response.data;
        } catch (error) {
            console.error('Erreur lors de la récupération des factures:', error);
            throw error;
        }
    },

    // Récupérer une facture par son ID
    async getFactureById(id) {
        try {
            const response = await axiosInstance.get(`/factures/${id}`);

            return response.data;
        } catch (error) {
            console.error(`Erreur lors de la récupération de la facture ${id}:`, error);
            throw error;
        }
    },

    // Créer une nouvelle facture
    async createFacture(factureData) {
        try {
            const response = await axiosInstance.post(`/factures`, factureData);

            return response.data;
        } catch (error) {
            console.error('Erreur lors de la création de la facture:', error);
            throw error;
        }
    },

    // Mettre à jour une facture
    async updateFacture(id, factureData) {
        try {
            const response = await axiosInstance.put(`/factures/${id}`, factureData);

            return response.data;
        } catch (error) {
            console.error(`Erreur lors de la mise à jour de la facture ${id}:`, error);
            throw error;
        }
    },

    // Supprimer une facture
    async deleteFacture(id) {
        try {
            const response = await axiosInstance.delete(`/factures/${id}`);

            return response.data;
        } catch (error) {
            console.error(`Erreur lors de la suppression de la facture ${id}:`, error);
            throw error;
        }
    },

    // Exporter les factures (PDF, Excel, etc.)
    async exportFactures(format = 'pdf', filters = {}) {
        try {
            const queryParams = new URLSearchParams({
                format,
                ...filters
            }).toString();

            const response = await axiosInstance.get(`/factures/export?${queryParams}`, {
                responseType: 'blob',
                headers: {
                    'Accept': `application/${format}`
                }
            });

            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export des factures:', error);
            throw error;
        }
    }
};

export default facturationService;
